module.exports = "<mp-multiple-choice-question-view\n  *ngIf=\"answerChoiceGroups.length == 1\"\n  [form]=\"form\"\n  [formGroup]=\"formGroup\"\n  [question]=\"question\"\n  [config]=\"config\"\n  >\n</mp-multiple-choice-question-view>\n\n<mp-table-analysis-question-view\n    *ngIf=\"answerChoiceGroups.length > 1\"\n    [form]=\"form\"\n    [formGroup]=\"formGroup\"\n    [question]=\"question\"\n    [config]=\"config\"\n  >\n</mp-table-analysis-question-view>\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mprep/shared/lib/angular/components/question-view/multi-source-reasoning-question-view/multi-source-reasoning-question-view.html
// module id = w/R4
// module chunks = 3